import JobList from '../../components/JobList';

const Jobs = () => {
  return (
    <div className='container'>
      <JobList />
    </div>
  );
};
export default Jobs;
